export const OPEN_WEATHER_KEY = '1b9e15e6fbdf803c0c51dbe4a9946757';
export const OPEN_WEATHER_URL = 'https://api.openweathermap.org/data/2.5/';
export const UNSPLASH_URL = 'https://api.unsplash.com/photos/random?query=';
export const UNSPLASH_KEY = 'SZva1MBfHM4PAg6lBDKQ9EVez1vnH__JuGQygwi_rKE';
export const MAPBOX_KEY = 'pk.eyJ1IjoiYW5kcm9tbmlyIiwiYSI6ImNrYXFmdWdsNjA1NXoycHFmOXhkZnBvZWkifQ.wZ4gnIJGgCfQsis3CezzFQ';
export const IP_INFO_URL = 'https://ipinfo.io/json?token=';
export const IP_INFO_KEY = '8de058c39b31a6';
export const OPEN_CAGE_DATA_URL = 'https://api.opencagedata.com/geocode/v1/json?q=';
export const OPEN_CAGE_DATA_KEY = '03cb5cbe414f44e6b304a3bd5a99d1e2';
export const KEY_YANDEX = 'trnsl.1.1.20200507T154953Z.447eb504d61f94c1.ed3070db979821486f8a3abe638847104f98eafd';
export const URL_YANDEX = 'https://translate.yandex.net/api/v1.5/tr.json/translate?';
